import { QueryFeature } from '../../../../../config/queryClient';

enum QueryKey {
  FirmSettings = 'FirmSettings',
}

export const queryKeys = {
  firmSettings: () => [QueryFeature.Settings, QueryKey.FirmSettings],
};
